"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestTracerIdKey = exports.REQUEST_TRACER_IDS_HEADER = void 0;
/** @TranslateToPython */
exports.REQUEST_TRACER_IDS_HEADER = 'x-request-tracer-ids';
/** @TranslateToPython */
var RequestTracerIdKey;
(function (RequestTracerIdKey) {
    RequestTracerIdKey["PARTNER_DETAILS_ID"] = "partnerDetailsId";
    RequestTracerIdKey["PARTNER_USER_ID"] = "partnerUserId";
    RequestTracerIdKey["PARTNER_INQUIRY_ID"] = "partnerInquiryId";
    RequestTracerIdKey["PARTNER_SUB_ORG_ID"] = "partnerSubOrgId";
})(RequestTracerIdKey || (exports.RequestTracerIdKey = RequestTracerIdKey = {}));
